import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import {
  SearchInputFocusable,
  SearchInput,
  SearchResultDiv,
  SearchResultTextWrapper,
  SearchResultTitle,
  SearchResultDescription,
} from 'components/SearchInput';
import { TruncatedSearchResult } from 'components/TruncatedSearchResult';

const StyledEventPhotoWrapper = styled.div`
  height: 24px;
  width: 50px;
  text-align: center;
`;
const StyledEventPhoto = styled.img`
  max-height: 24px;
  max-width: 50px;
`;

const ResultItem = ({ result, term, onClick, dateFormat }) => {
  const event = result;

  const imgNode = event.photo ? (
    <StyledEventPhoto
      data-testid="searchResultEventPhoto"
      src={event.photo}
      alt={`${event.title} logo`}
    />
  ) : null;

  return (
    <SearchResultDiv
      data-testid={`searchResult-${event.title}`}
      onClick={onClick.bind(null, event)}
    >
      <StyledEventPhotoWrapper>{imgNode}</StyledEventPhotoWrapper>
      <SearchResultTextWrapper>
        <SearchResultTitle data-testid="searchResultTitle">
          <TruncatedSearchResult result={result} term={term}/>
        </SearchResultTitle>
        <SearchResultDescription data-testid="searchResultDates">
          {moment(event.startOn).format(dateFormat)} —{' '}
          {moment(event.endOn).format(dateFormat)}
        </SearchResultDescription>
        <SearchResultDescription data-testid="searchResultLocation">
          {event.venue && `${event.venue}`}
        </SearchResultDescription>
      </SearchResultTextWrapper>
    </SearchResultDiv>
  );
};

const EventSearchInput = ({
  dateFormat,
  onChange,
  onResultClick,
  onCancel,
  value,
  results,
}) => {
  return (
    <SearchInput
      {...{
        onChange,
        onResultClick,
        onCancel,
        value,
        results,
        ResultItem,
        dateFormat,
        tooltipProps: {
          id: 'event-search-input',
          placement: 'bottom-end',
          title: 'Find a specific Event',
        },
      }}
    />
  );
};

export default EventSearchInput;

export { SearchInputFocusable, ResultItem };
